import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, colors, Grid, IconButton, } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useTranslation } from "react-i18next";
import DataTable from '../components/common/DataTable';
import MessageBox from "../components/common/CustomMessageBox";
import CustomDelete from '../components/common/CustomDeleteAlert';
import CustomModal from "../components/common/CustomModal";
import Createimportshipement from "../components/importshipement/createimportshipement";
import UpdateImportshipement from "../components/importshipement/UpdateImportshipement";
import { DELETE_IMPORT_SHIPMENT, LIST_ALL_IMPORT_SHIPMENT } from "../services/apiRoutes";
import axios from "axios";
import { formatDate, getCIFFOBList, getColorById, getColorPlate, getCountries, getCurrencyList, getPaymentMethod, getPortMasters, getShipmentTypes, getSuppliersList } from "../services/CommonServices";
import { AuthContext } from "../context/AuthContext";
import CustomLoader from "../components/common/CustomLoader";
import CustomFilter from "../components/common/CustomFilter";
import CustomAutocomplete from "../components/common/CustomAutoComplete";
import CustomTextField from "../components/common/CustomTextField";
import CustomButton from "../components/common/CustomButton";
import { ClearRounded, } from "@mui/icons-material";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import CustomStatus from "../components/common/CustomStatus";
import { genericPost } from "../services/authServices";
import { hasEditPermission, hasDeletePermission } from '../services/CommonServices'
import { useLocation } from "react-router-dom";
import { useCompanyDateFormat } from "../constants/useCompanyDateFormat";
import CustomDataTable from "../components/common/CustomDataTable";
import ImportCompareView from "../components/importshipement/ImportCompareView";
import CompareOutlinedIcon from '@mui/icons-material/CompareOutlined';

const title = 'importShipment';

const ImportShipment = () => {
  const companyDateFormat = useCompanyDateFormat();
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [importShipments, setImportShipments] = useState([]);
  const [newShippingId, setNewShippingId] = useState(null);
  const [impShipmentId, setImpShipmentId] = useState(null);
  const [permission, setPermissions] = useState()
  const [cifFobList, setCIFFOBList] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [portMasters, setPortMasters] = useState([]);
  const [shipmentTypes, setShipmentTypes] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [suppliersList, setSuppliersList] = useState([]);
  const [conutries, setConutries] = useState([]);
  const { token } = useContext(AuthContext)
  const [openDrawer, setOpenDrawer] = useState(false);
  const [page, setPage] = useState(0); // UI 0-based
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [viewModal, setViewModal] = useState(false);
  const [importShipmentId, setimportShipmentId] = useState('');
  const [colorlist, setColorlist] = useState([]);

  const [message, setMessage] = useState({
    open: false,
    text: '',
    type: ''
  });
  const [filterPayload, setFilterPayload] = useState({
    shipmentId: '',
    supplierId: '',
    cifFobId: '',
    currencyId: '',
    shipmentTypeId: '',
    fromDate: '',
    toDate: '',
  });
  const [activeButton, setActiveButton] = useState(null);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [rowId, setRowId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const filterOpen = () => setOpenDrawer(true);
  const filterClose = () => setOpenDrawer(false);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleUpdateClick = (importShipmentId) => {
    setSelectedId(importShipmentId);
    setUpdateModal(true);
  };

  const handleOpenDeleteAlert = (rowId) => {
    setDeleteAlert(true);
    setRowId(rowId);
  };

  const handleCloseUpdate = () => {
    setUpdateModal(false);
  };
  const handleFilterChange = (field, value) => {
    setFilterPayload((prev) => ({
      ...prev,
      [field]: value || '',
    }));
  };

  const handleFOBClick = () => {
    setActiveButton("2");
    setFilterPayload((prev) => ({
      ...prev,
      cifFobId: "1",
    }));
    fetchImportShipments();
  };
  const handleCIFClick = () => {
    setActiveButton("1");
    setFilterPayload((prev) => ({
      ...prev,
      cifFobId: "2",
    }));
    fetchImportShipments();
  };

  const handleClearFilters = useMemo(() => {
    return () => {
      setFilterPayload({
        shipmentId: '',
        supplierId: '',
        cifFobId: '',
        currencyId: '',
        shipmentTypeId: '',
        fromDate: '',
        toDate: '',
      });
      fetchImportShipments(0, pageSize, '');
      setActiveButton(null);
    };
  }, [pageSize]);


  const handleDelete = async (importShipmentId) => {
    setLoading(true);
    const authToken = sessionStorage.getItem('accessToken');
    try {
      const response = await axios.delete(DELETE_IMPORT_SHIPMENT(importShipmentId), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 200) {
        fetchImportShipments();
        setDeleteAlert(false);
        setMessage({
          open: true,
          text: response?.data?.message || "Delete successfully",
          type: "success",
        });
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error deleting import shipment", error);
    }
  };

  const location = useLocation();
  const currentPath = location.pathname;
  useEffect(() => {
    let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
    let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
    let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
    setPermissions({
      edit: editPermision,
      delete: deletePermission
    })
  }, [])

  useEffect(() => {
    fetchImportShipments(page, pageSize)
  }, [token, page, pageSize, colorlist])

  useEffect(() => {
    getCommonData();
  }, []);

  const getCommonData = async () => {
    const cifFobListData = await getCIFFOBList();
    setCIFFOBList(cifFobListData);
    const shipmentTypesData = await getShipmentTypes();
    setShipmentTypes(shipmentTypesData);
    const currencyListData = await getCurrencyList();
    setCurrencyList(currencyListData);
    const suppliersListData = await getSuppliersList();
    setSuppliersList(suppliersListData);
    const getConutriesData = await getCountries()
    setConutries(getConutriesData);
    const getPaymentMethodData = await getPaymentMethod()
    setPaymentMethod(getPaymentMethodData);
    const getPortMastersData = await getPortMasters()
    setPortMasters(getPortMastersData);
    const colorData = await getColorPlate();
    setColorlist(colorData);
  }



  const columns = useMemo(
    () => [
      { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
      { accessorKey: "shipmentDate", header: "Date", size: 100, tableStyle: { textAlign: "center" }, enableSorting: false, },
      { accessorKey: "shipmentId", header: "Shipment ID", size: 50, tableStyle: { textAlign: "center" }, enableSorting: false, },
      {
        accessorKey: "supplierName", header: "Supplier Name", size: 200, enableSorting: false,
        tableHeader: {
          justifyContent: 'flex-start',
        },
      },
      {
        accessorKey: "countryName",
        header: "Country",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.countryName}
              sx={{
                backgroundColor: row.original.countryIdBackground,
                color: row.original.countryIdColor,
                border: `1px solid ${row.original.countryIdColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },
      {
        accessorKey: "paymentMethodName",
        header: "Payment Method",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.paymentMethodName}
              sx={{
                backgroundColor: row.original.paymentBgColor,
                color: row.original.paymentColor,
                border: `1px solid ${row.original.paymentColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },
      { accessorKey: "noOfContainers", header: "No. of Container", size: 50, tableStyle: { textAlign: "center" }, enableSorting: false, },
      {
        accessorKey: "currency", header: "Currency", size: 50, enableSorting: false,
        tableHeader: {
          justifyContent: 'flex-start',
        },
      },
      {
        accessorKey: "loadingName",
        header: "Port Of Loading",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.loadingName}
              sx={{
                backgroundColor: row.original.portOfLoadingBackground,
                color: row.original.portOfLoadingColor,
                border: `1px solid ${row.original.portOfLoadingColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },
      {
        accessorKey: "destinationName",
        header: "Port Of Destination",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.destinationName}
              sx={{
                backgroundColor: row.original.portOfDestinationBackground,
                color: row.original.portOfDestinationColor,
                border: `1px solid ${row.original.portOfDestinationColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },

      {
        accessorKey: "cifFobName",
        header: "CIF/FOB",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.cifFobName}
              sx={{
                backgroundColor: row.original.cifFobBgColor,
                color: row.original.cifFobColor,
                border: `1px solid ${row.original.cifFobColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },

      {
        accessorKey: "compare",
        header: "compare",
        size: 100,
        enableSorting: false,
        Cell: ({ row }) => (
          <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
              <IconButton onClick={() => handleViewClick(row.original.importShipmentId)}>
                <CompareOutlinedIcon style={{ color: "#1976D2" }} />
              </IconButton>
            </div>
          </>
        ),
      },
      {
        accessorKey: "action",
        header: "Action",
        size: 100,
        enableSorting: false,
        Cell: ({ row }) => (
          <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
              <IconButton onClick={() => handleViewClickView(row.original.importShipmentId)}>
                <VisibilityIcon style={{ color: "#059212" }} />
              </IconButton>
              {permission?.edit &&
                <IconButton onClick={() => handleUpdateClick(row.original.importShipmentId)}>
                  <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                </IconButton>
              }
              {permission?.delete && <IconButton onClick={() => handleOpenDeleteAlert(row.original.importShipmentId)}>
                <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
              </IconButton>}
            </div>
          </>
        ),
      },
    ],
    [permission]
  );

  const formatPortName = (port, country) => {
    return [port, country].filter(Boolean).join(", ");
  };



  const fetchImportShipments = async (pageIndex = 0, pageSize = 10) => {
    setLoading(true);
    try {
      const payload = {
        page: pageIndex + 1,
        limit: pageSize,
        ...filterPayload
      };
      const response = await genericPost(LIST_ALL_IMPORT_SHIPMENT, payload, {});
      if (response.data.success && response.data.shipments) {
        const { newShippingId, lastShipmentId, shipments, impShipmentId } = response.data;
        const shipmentData = response.data.shipments.map((shipment, index) => {
          const countryColorObj = getColorById(shipment?.supplier?.billingCountry?.id, colorlist, {
            matchKey: "colorId",
            prefixLength: 1,
          });
          return {
            index: (index + 1).toString().padStart(2, '0'),
            importShipmentId: shipment.importShipmentId || '',
            supplierId: shipment.supplierId || '',
            shipmentId: shipment.shipmentId || '',
            createdAt: formatDate(shipment.createdAt) || '',
            noOfContainers: shipment.noOfContainers || '',
            // shipmentDate: shipment.shipmentDate || '',
            shipmentDate: companyDateFormat(shipment?.shipmentDate) || '',
            cifFobName: shipment.cifFob.cifFobName || '',
            cifFobId: shipment.cifFob.cifFobId || '',
            paymentMethodName: shipment?.paymentMethod?.paymentMethodName || '',
            supplierName: shipment.supplier.clientCompanyName || '',
            countryName: shipment.supplier.billingCountry.name || '',
            expectedEtd: shipment?.expectedEtd || '',
            cifFobColor: shipment.cifFob?.ColorPlate?.color || '',
            cifFobBgColor: shipment.cifFob?.ColorPlate?.backgroundColor || '',
            paymentColor: shipment?.paymentMethod?.ColorPlate?.color || '',
            paymentBgColor: shipment?.paymentMethod?.ColorPlate?.backgroundColor || '',
            currency: `${shipment.currency?.currency_symbol || ''} (${shipment.currency?.currency || ''}) - ${shipment.currency?.currency_name || ''}`,
            portOfLoading: shipment.portOfLoading || '',
            portOfDestination: shipment.portOfDestination || '',
            loadingName: formatPortName(
              shipment?.loading?.portName,
              shipment?.loading?.country?.name
            ),
            destinationName: formatPortName(
              shipment?.destination?.portName,
              shipment?.destination?.country?.name
            ),
            countryIdColor: countryColorObj.color || '',
            countryIdBackground: countryColorObj.backgroundColor || '',

            portOfLoadingColor: shipment?.loading?.ColorPlate?.color || '',
            portOfLoadingBackground: shipment?.loading?.ColorPlate?.backgroundColor || '',

            portOfDestinationColor: shipment?.destination?.ColorPlate?.color || '',
            portOfDestinationBackground: shipment?.destination?.ColorPlate?.backgroundColor || '',
          };
        });
        setImportShipments(shipmentData);
        setNewShippingId(newShippingId);
        setImpShipmentId(impShipmentId)
        setRowCount(response.data.pagination?.totalRecords || 0);

      } else {
        setError('No import shipments found');
      }
    } catch (error) {
      setError('Error fetching import shipments');
      console.error('Error fetching import shipments', error);
    } finally {
      setLoading(false);
    }
  };

  // if (loading) return <p>Loading...</p>;
  // if (error) return <p>{error}</p>;

  const handleOpen = () => {
    setModal(true);
  };

  const handleClose = () => {
    setModal(false);
  };
  const handleOpenView = (id) => {
    setimportShipmentId(id);
    setViewModal(true);
  };

  const handleCloseView = () => {
    setViewModal(false);
    setimportShipmentId('');
  };

  const handleViewClick = (id) => {
    handleOpenView(id);
  };

  const handleViewClickView = (importShipmentId) => {
    navigate(`/app/import/shipementview/${importShipmentId}`);
  };

  const cif_fob_style = {
    backgroundColor: '#ffff',
    color: '#007bff',
    textTransform: "capitalize",
    borderRadius: 4,
    border: '1px solid #007bff',
    height: 30,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "100px"

  }

  return (
    <>
      <Box sx={{ padding: '10px' }}>
        <CustomLoader open={loading} />
        <CustomDataTable
          title={title}
          columns={columns}
          data={importShipments}
          handleOpen={handleOpen}
          buttonTitle="Create"
          handleFilterButton={filterOpen}
          fiterButtonTitile="Filter"
          rowCount={rowCount}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          fromDate={filterPayload.fromDate || ""}
          toDate={filterPayload.toDate || ""}

        />
        <CustomModal open={modal}  >
          <Createimportshipement
            handleClose={handleClose}
            fetchImportShipments={fetchImportShipments}
            setMessage={setMessage}
            cifFobList={cifFobList}
            shipmentTypes={shipmentTypes}
            currencyList={currencyList}
            suppliersList={suppliersList}
            paymentMethod={paymentMethod}
            newShippingId={newShippingId}
            impShipmentId={impShipmentId}
            portMasters={portMasters}

          />
        </CustomModal>

        <CustomModal open={updateModal}  >
          <UpdateImportshipement
            handleClose={handleCloseUpdate}
            importShipmentId={selectedId}
            fetchImportShipments={fetchImportShipments}
            setMessage={setMessage}
            cifFobList={cifFobList}
            shipmentTypes={shipmentTypes}
            currencyList={currencyList}
            paymentMethod={paymentMethod}
            suppliersList={suppliersList}
            portMasters={portMasters}
          />
        </CustomModal>

        <CustomModal
          open={viewModal}
          handleClose={handleCloseView}>
          <ImportCompareView
            handleClose={handleCloseView}
            importShipmentId={importShipmentId}
          />
        </CustomModal>


        <MessageBox
          open={message.open}
          onClose={() => setMessage({ ...message, open: false })}
          message={message.text}
          handleClose={() => setMessage({ ...message, open: false })}
          type={message.type}
        />
        <CustomDelete
          handleDelete={handleDelete}
          open={deleteAlert}
          rowId={rowId}
          handleClose={() => setDeleteAlert(false)}
        />

        <CustomFilter
          drawerTitle="Filter"
          drawerWidth={300}
          openDrawer={openDrawer}
          onClose={filterClose}
          drawerContent={
            <>
              <Box>
                <Grid container spacing={1} sx={{ padding: 0, }}>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomTextField
                      type="text"
                      placeholder="Enter Shipment ID"
                      value={filterPayload.shipmentId}
                      onChange={(e) => handleFilterChange('shipmentId', e.target.value)}

                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomAutocomplete
                      options={suppliersList}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Supplier"
                      onChange={(event, newValue) => handleFilterChange("supplierId", newValue?.id)}
                      value={suppliersList.find((item) => item.id === filterPayload.supplierId) || null}

                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomAutocomplete
                      options={currencyList}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Currency"
                      onChange={(event, newValue) => handleFilterChange("currencyId", newValue?.id)}
                      value={currencyList.find((item) => item.id === filterPayload.currencyId) || null}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomTextField
                      fieldLabel="From Date"
                      type="date"
                      value={filterPayload.fromDate}
                      onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                      placeholder="From Date"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomTextField
                      fieldLabel="To Date"
                      type="date"
                      value={filterPayload.toDate}
                      onChange={(e) => handleFilterChange('toDate', e.target.value)}
                      placeholder="To Date"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <CustomButton
                      onClick={handleCIFClick}
                      title="CIF"
                      size="small"
                      variant="outlined"
                      style={{
                        ...cif_fob_style,
                        ...(activeButton === "1" ? activeStyle : {}),
                      }}
                    />
                    <CustomButton
                      onClick={handleFOBClick}
                      title="FOB"
                      size="small"
                      variant="outlined"
                      style={{
                        ...cif_fob_style,
                        ...(activeButton === "2" ? activeStyle : {}),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                    <CustomButton
                      startIcon={<FindReplaceOutlinedIcon />}
                      title="Apply"
                      size="small"
                      variant="contained"
                      onClick={fetchImportShipments}
                    />
                    <CustomButton
                      variant="outlined"
                      title="Clear"
                      startIcon={<ClearRounded />}
                      style={cif_fob_style}
                      onClick={handleClearFilters}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          }
        />
      </Box >
    </>
  );
};

export default ImportShipment;

const activeStyle = {
  backgroundColor: "#007BFF",
  color: "#ffffff",
  border: "1px solid #007BFF",
};
